// Centralized feature flags
// Reads from runtime runtime-config injection first (window.RUNTIME_CONFIG OR window.__RUNTIME_CONFIG__),
// then CRA-exposed env vars (those beginning with REACT_APP_), then finally any un-prefixed vars
// (not normally exposed by CRA but we attempt for robustness if build tooling was customized).
// Add new flags carefully and document expected removal timeline.

function bool(val) {
  if (val === true) return true;
  if (typeof val === 'string') return /^(1|true|yes|on)$/i.test(val.trim());
  return false;
}

const rc = (typeof window !== 'undefined'
  ? (window.RUNTIME_CONFIG || window.__RUNTIME_CONFIG__ || {})
  : {});

// Support both runtime + REACT_APP_ prefix + unprefixed fallback for resilience
export const PAYMENTS_FEATURE_ENABLED = bool(
  rc.PAYMENTS_FEATURE_ENABLED ||
  rc.REACT_APP_PAYMENTS_FEATURE_ENABLED ||
  process.env.REACT_APP_PAYMENTS_FEATURE_ENABLED ||
  process.env.PAYMENTS_FEATURE_ENABLED ||
  'true'
);
export const USER_SIGNUP_ENABLED = bool(
  rc.USER_SIGNUP_ENABLED ||
  rc.REACT_APP_USER_SIGNUP_ENABLED ||
  process.env.REACT_APP_USER_SIGNUP_ENABLED ||
  process.env.USER_SIGNUP_ENABLED ||
  'true'
);

// Mobile app readiness flag - gates mobile-specific features like auto-login redirect
// TODO: Enable when mobile app authentication flow is ready
export const MOBILE_APP_READY = false;

// Study Guide / My Progress feature flag
export const STUDY_GUIDE_ENABLED = bool(
  rc.STUDY_GUIDE_ENABLED ||
  rc.REACT_APP_STUDY_GUIDE_ENABLED ||
  process.env.REACT_APP_STUDY_GUIDE_ENABLED ||
  'false'
);

// Key Terms tool visibility flag - gates Key Terms tool in ScoutsDesk
// TODO: Enable when Key Terms feature is ready for release
export const FEATURE_KEY_TERMS = false;

// Onboarding V2 - redesigned multi-step onboarding wizard
// Gates the new personalized onboarding flow (profile setup, guided syllabus upload,
// productive scan wait, hands-on feature walkthrough)
export const ONBOARDING_V2_ENABLED = bool(
  rc.ONBOARDING_V2_ENABLED ||
  rc.REACT_APP_ONBOARDING_V2_ENABLED ||
  process.env.REACT_APP_ONBOARDING_V2_ENABLED ||
  'true'
);

// Potential future flags (example placeholders)
// export const GPT_ADVANCED_ANALYTICS_ENABLED = bool(rc.GPT_ADVANCED_ANALYTICS_ENABLED || process.env.REACT_APP_GPT_ADVANCED_ANALYTICS_ENABLED);

export function isPaymentsEnabled() { return PAYMENTS_FEATURE_ENABLED; }
export function isUserSignupEnabled() { return USER_SIGNUP_ENABLED; }
export function isMobileAppReady() { return MOBILE_APP_READY; }

if (process.env.NODE_ENV !== 'production') {
  // Helpful one-time console log for debugging flag state in development
  // (Avoid noisy logs in production.)
  // eslint-disable-next-line no-console
  console.debug('[featureFlags] Evaluated flags:', {
    PAYMENTS_FEATURE_ENABLED,
    USER_SIGNUP_ENABLED,
    MOBILE_APP_READY,
    STUDY_GUIDE_ENABLED,
    ONBOARDING_V2_ENABLED,
    runtimeKeys: Object.keys(rc)
  });
}

const featureFlags = { PAYMENTS_FEATURE_ENABLED, USER_SIGNUP_ENABLED, MOBILE_APP_READY, STUDY_GUIDE_ENABLED, ONBOARDING_V2_ENABLED };
export default featureFlags; // Named variable to satisfy import/no-anonymous-default-export
